<template>
  <van-popup
    position="bottom"
    :value="isPopup"
    @click-overlay="$emit('close')"
    @close="$emit('close')"
    :style="{ height: popupHeight }"
  >
    <div class="popup-title__box">
      <div class="popup-title__label">{{ title }}</div>
      <div class="popup-title__icon" @click="$emit('close')">
        <img src="@/assets/refund/down.png" alt="" srcset="" />
      </div>
    </div>

    <van-tree-select
      :class="type"
      :items="areaList"
      :active-id.sync="activeId"
      :main-active-index.sync="activeIndex"
      @click-item="handleSelect"
      :style="{ height: 'calc(100% - 56px)' }"
    />
  </van-popup>
</template>

<script>
/**
 * 使用方式，实现双向绑定 v-model，地区code
 * 需传入 isPopup 用于弹窗展示
 * @close 关闭弹窗
 * @confirm 确定时返回 label 选中标签， 地区code
 */

import { mapGetters, mapActions } from "vuex";
import api from "../../../../service/modules/refund";
// 弹窗管理总栈

export default {
  name: "PopupBus",
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "落点区域",
    },
    type: {
      type: String,
      default: "double", // single 单列, double 双列
    },
    adcode: {
      type: String,
      default: "530000", // 左侧 地区code, 只在 type 为 single 时生效
    },
  },
  data() {
    return {
      activeIndex: 0,
      activeId: "",
      areaList: [],
      popupHeight: "332px",
      regionCode: "",//区域代码
      regionType: "",//登录人身份
    };
  },
  created() {
    // this.getRegion()
    
  },
  watch: {
    adcode: {
      handler(val) {
        this.initArea();
        if (this.type === "single") {
          let index = this.areaList.findIndex((city) => {
            // console.log(city);
            return (
              city.id === val || !!city.children.find((area) => area.id === val)
            );
          });

          console.log(val, index);

          this.activeIndex = index >= 0 ? index : 0;
          // this.activeId = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("refund", {
      setRegionList: "setRegionList",
    }),
    async initArea() {
      try {
        (this.regionList && this.regionList.length) || (await this.setRegionList());
        console.log('regionList', this.regionList);
        api
        .currentUser()
        .then((res) => {
          if(res.ret == 0) {
            let regionCode = res.data.regionCode;
            let regionType = res.data.regionType;
            console.log(regionCode,regionType);
            const areaLists = this.regionList[0].children
            
            const areaList = []
            areaLists.forEach((item, index) => {
              if(regionType == "1") {
                areaList.push({
                  id: item.code,
                  text: item.name,
                  regionType: item.regionType,
                  children: [],
                  disabled: false, //身份为省级
                });
                if(item.children) {
                  item.children.forEach(data => {
                    areaList[index].children.push({
                      id:data.code,
                      text: data.name,
                      regionType: data.regionType,

                    })
                })
                areaList[index].children.unshift({ id: 'self'+ item.code, text: "市级", regionType: '3', });
                areaList[index].children.unshift({ id: item.code, text: "全部", regionType: '3', });
              }
              }else if(regionType == "2") {
                if(item.code == regionCode) {
                  areaList.push({
                    id: item.code,
                    text: item.name,
                  regionType: item.regionType,

                    children: [],
                  });
                  console.log(areaList);
                  if(item.children) {
                    item.children.forEach(data => {
                      areaList[0].children.push({
                        id:data.code,
                        text: data.name,
                  regionType: data.regionType,

                      })
                    })
                    areaList[0].children.unshift({ id: 'self'+ item.code, text: "市级",regionType: '2' });
                    areaList[0].children.unshift({ id: item.code, text: "全部", regionType: '2' });
                  }
                }
              }


              // if(item.code == regionCode) {
              //   areaList.push({
              //   id: item.code,
              //   text: item.name,
              //   children: [],
              //   disabled: false, //身份不为省级
              // });
              // }else {
              //   areaList.push({
              //   id: item.code,
              //   text: item.name,
              //   children: [],
              //   disabled: regionType != "1", //身份不为省级
              // });
              // }
              
            });
            if(regionType == "1") {
              areaList.unshift({
                text: "云南省",
                id: "530000",
                children: [
                  { text: "全部州市", id: "530000", regionType: '2', },
                  { text: "省级", id: "self530000", regionType: '3', },
                ],
              });
            }

            console.log("areaList", areaList);
            this.$set(this, "areaList", areaList);
          }
        })
        // const areaList = this.regionList[0].children
        //   .filter((item) => +item.code)
        //   .map((item) => ({
        //     text: item.shortName,
        //     id: item.code,
        //     children: [
        //       { text: "全部区县", id: item.code },
        //       ...item.children.map((area) => ({
        //         text: area.shortName,
        //         id: area.code,
        //       })),
        //     ],
        //   }));
        
      } catch (err) {
        console.log(err);
        const areaList = [];

        areaList.unshift({
          text: "云南省",
          id: "530000",
          children: [{ text: "全部州市", id: "530000" }],
        });

        console.log("error areaList", areaList);
        this.$set(this, "areaList", areaList);
      }
    },
    // 格式化地区
    setAreaItem(arealist) {
      // console.log("setAreaItem", arealist);
      const areaArr = arealist.map((item) => ({
        text: item.shortName,
        id: item.code,
        disabled: false,
        children: item.children ? this.setAreaItem(item.children) : "",
      }));

      areaArr.forEach((area) => {
        !area.children && delete area.children;
      });

      return areaArr;
    },
    // 选择地区
    handleSelect(data) {
      console.log('地区', data);
      if (data.regionType == 3) {
        this.$emit("confirm", data.text, data.id, '1');
      } else {
        this.$emit("confirm", data.text, data.id, '2');
      }
      this.$emit("input", data.id);
      // this.$emit("confirm", data.text, data.id);
      this.$emit("close");
      
    },
  },
  computed: {
    ...mapGetters("refund", {
      regionList: "getRegionList",
    }),
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-popup {
  border-radius: 4px 4px 0px 0px;
}

.popup-title__box {
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  font-family: PingFangSC-Semibold;
  font-weight: Semibold;
  line-height: 56px;
  font-size: 16px;
  color: #171a1d;
  letter-spacing: 0;
  line-height: 16px;
  filter: blur(10);

  .popup-title__icon {
    > img {
      width: 16px;
      height: 16px;
    }
  }
}

/deep/ .van-tree-select {
  &.single {
    .van-tree-select__nav {
      width: 0;
    }
  }
  .van-tree-select__nav {
    flex: none;
    width: 100px;
    background-color: #ffffff;

    .van-sidebar-item {
      line-height: 36px;
      padding: 0 16px;
      background-color: #ffffff;

      height: 36px;
      font-family: PingFangSC-Regular;
      font-weight: Regular;
      font-size: 14px;
      color: #171a1d;
      letter-spacing: 0;
      filter: blur(10);
    }

    .van-sidebar-item--select {
      color: #36b374;

      &::before {
        background-color: transparent;
      }
    }
  }

  .van-tree-select__content {
    background-color: #f9fafc;

    .van-tree-select__item {
      line-height: 36px;
      padding: 0 20px;

      height: 36px;
      font-family: PingFangSC-Regular;
      font-weight: Regular;
      font-weight: 500;
      font-size: 14px;
      color: #171a1d;
      letter-spacing: 0;
      filter: blur(10);
    }

    .van-tree-select__item--active {
      color: #36b374;
    }
  }
  .van-sidebar-item--disabled{
    color: #c8c9cc !important;
  }
  .van-tree-select__item--disabled{
    color: #c8c9cc !important;
  }
}
</style>
